import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onClick: () => void;
  className?: string;
}

const TodayButton: React.FC<Props> = ({ onClick, className }) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <button
        type="button"
        className="a no-styling"
        onClick={onClick}
      >
        {t('waste_calendar.navigation.today')}
      </button>
    </div>
  );
};

export default TodayButton;
